export default __webpack_public_path__ + "static/media/other-accommodation.bbe2f61c.svg";